module.exports = __webpack_public_path__ + "img/error.59cacc9b.svg";